module.exports = __webpack_public_path__ + "img/c4a7989.jpg";